function customSlider () {
    var flkty = new Flickity( '.customSlider', {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false
    });

    var prevButton = document.querySelector('.custom-prev-button');
    var nextButton = document.querySelector('.custom-next-button');

    prevButton.addEventListener('click', function() {
    flkty.previous();
    });

    nextButton.addEventListener('click', function() {
    flkty.next();
    });

    // Disable buttons at first/last slide
    function updateArrows() {
    var index = flkty.selectedIndex;

    prevButton.disabled = index === 0;
    nextButton.disabled = index === flkty.slides.length - 1;
    }

    // Run once at start
    updateArrows();

    // Run on slide change
    flkty.on('change', updateArrows);
}

function lookBookScroll () {
  var slider = document.querySelector('.customSlider');
  if (!slider) return;

  var flkty = Flickity.data(slider);

  document.querySelectorAll('.hot-spot .hot-spot__dot').forEach(dot => {
    dot.addEventListener('click', () => {
      let targetId = dot.getAttribute('data-target');
      let targetSlide = document.getElementById(targetId);

      if (!targetSlide) return;
      
      // FIND INDEX OF THE SLIDE
      let slideIndex = flkty.slides.findIndex(s => s.cells[0].element.id === targetId);

      if (slideIndex >= 0) {
        flkty.select(slideIndex);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  customSlider();
  lookBookScroll();
});

// Product view more media gallery start
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("desktop-view-more-media");

  if (btn) {
    if (window.innerWidth < 768) {
      btn.style.display = "none";
    }

    btn.addEventListener("click", function () {
      if (window.innerWidth >= 768) {
        document.querySelectorAll(".desktop-hidden-media").forEach(el => {
          el.style.display = "block";  // This will now work because CSS has no !important
        });
        btn.style.display = "none";
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth < 768) {
        btn.style.display = "none";
      } else if (document.querySelectorAll(".desktop-hidden-media").length > 0) {
        btn.style.display = "block";
      }
    });
  }
});




// Product view more media gallery end

// Product media video popup start
  document.addEventListener("DOMContentLoaded", () => {

    
  document.querySelectorAll("[data-video-trigger]").forEach(el => {
    el.addEventListener("click", () => {
      const id = el.getAttribute("data-video-trigger");
      const modal = document.getElementById(`video-modal-${id}`);
      const videoContainer = modal.querySelector(".popup-video-container");

      modal.style.display = "flex";
      document.body.classList.add("no-scroll");
      
      videoContainer.classList.add("active");
    });
  });

    function stopVideo(modal) {
      const iframe = modal.querySelector("iframe");
      const video = modal.querySelector("video");
      const videoContainer = modal.querySelector(".popup-video-container");
      const playButton = modal.querySelector(".popup-play-btn");

      
      videoContainer.classList.remove("active");
      playButton.style.display = "block";

      
      if (iframe) {
        iframe.src = iframe.src;
      }
      
      if (video) {
        video.pause();
      }
    }

    document.querySelectorAll(".video-modal").forEach(modal => {
      modal.addEventListener("click", e => {
        if (e.target === modal) {
          modal.style.display = "none";
          stopVideo(modal);
          document.body.classList.remove("no-scroll");

        }
      });
    });

    document.querySelectorAll("[data-video-popup-play]").forEach(btn => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-video-popup-play");
        const modal = document.getElementById(`video-modal-${id}`);

        const videoContainer = modal.querySelector(".popup-video-container");
        const iframe = modal.querySelector("iframe");
        const video = modal.querySelector("video");

        btn.style.display = "none";
        videoContainer.classList.add("active");

        if (iframe && iframe.src.includes("youtube")) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: "command", func: "playVideo" }), "*"
          );
        }

        if (iframe && iframe.src.includes("vimeo")) {
          iframe.contentWindow.postMessage({ method: "play" }, "*");
        }

        if (video) {
          video.play();
        }
      });
    });

  });
// Product media video popup end

// image with accordion start
  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-item');

    const first = accordions[0];
    if (first) {
      const firstContent = first.querySelector('.accordion-content');
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    }

    accordions.forEach((item) => {
      const header = item.querySelector('.accordion-header');

      header.addEventListener('click', () => {
        const content = item.querySelector('.accordion-content');
        const plus = item.querySelector('.icon-plus');
        const minus = item.querySelector('.icon-minus');

        if (item.classList.contains('active')) {
          item.classList.remove('active');
          content.style.maxHeight = null;
          plus.style.display = 'inline-block';
          minus.style.display = 'none';
        } else {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          plus.style.display = 'none';
          minus.style.display = 'inline-block';
        }
      });
    });
  });
  // image with accordion end


// Hotspot section start
function customSlider () {
    var flkty = new Flickity( '.customSlider', {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false
    });

    var prevButton = document.querySelector('.custom-prev-button');
    var nextButton = document.querySelector('.custom-next-button');

    prevButton.addEventListener('click', function() {
    flkty.previous();
    });

    nextButton.addEventListener('click', function() {
    flkty.next();
    });

    // Disable buttons at first/last slide
    function updateArrows() {
    var index = flkty.selectedIndex;

    prevButton.disabled = index === 0;
    nextButton.disabled = index === flkty.slides.length - 1;
    }

    // Run once at start
    updateArrows();

    // Run on slide change
    flkty.on('change', updateArrows);
}

function lookBookScroll () {
  var slider = document.querySelector('.customSlider');
  if (!slider) return;

  var flkty = Flickity.data(slider);

  document.querySelectorAll('.hot-spot .hot-spot__dot').forEach(dot => {
    dot.addEventListener('click', () => {
      let targetId = dot.getAttribute('data-target');
      let targetSlide = document.getElementById(targetId);

      if (!targetSlide) return;
      
      // FIND INDEX OF THE SLIDE
      let slideIndex = flkty.slides.findIndex(s => s.cells[0].element.id === targetId);

      if (slideIndex >= 0) {
        flkty.select(slideIndex);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  customSlider();
  lookBookScroll();
});
// Hotspot section end


// Blog video channel video popup start 
 document.addEventListener("DOMContentLoaded", function() {  
  var carousel = document.querySelector('.js-video-carousel');
  let isDragging = false;
  let flkty = null;
  const isMobile = window.innerWidth < 768;

  if (carousel) {
      flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      wrapAround:  false,
      pageDots: false,
      prevNextButtons: false,
      freeScroll: true,
      groupCells: 2,
      // draggable: true,
      draggable: !isMobile,
      rightToLeft: false
    });
    flkty.on('dragStart', function () {
    isDragging = true;
  });

  flkty.on('dragEnd', function () {
    // allow click again after short delay
    setTimeout(() => { 
      isDragging = false; 
    }, 50);
  });

  const navPrev = document.querySelector('.video-carousel-nav__prev');
  const navNext = document.querySelector('.video-carousel-nav__next');
  if (navPrev) navPrev.addEventListener('click', () => flkty.previous());
  if (navNext) navNext.addEventListener('click', () => flkty.next());

  const updateNavState = () => {
    const selectedIndex = flkty.selectedIndex;
    const lastIndex = flkty.slides.length - 1;
    navPrev.classList.toggle('is-inactive', selectedIndex === 0);
    navNext.classList.toggle('is-inactive', selectedIndex === lastIndex); 
  };

  flkty.on('select', updateNavState);
  updateNavState(); 

  }




  

  const modal = document.getElementById('video-popup-modal');
  const backdrop = modal.querySelector('.modal-backdrop'); 
  const videoTriggers = document.querySelectorAll('.video-trigger');
  const popupPlayOverlay = document.getElementById('popup-play-overlay');
  const popupPlayButton = document.getElementById('popup-play-button');
  const iframeContainer = document.getElementById('video-player-iframe-container');
  const popupThumbnail = document.getElementById('popup-thumbnail'); 

  let currentVideoId = '';
  let currentVideoHost = '';

  const openModal = (videoId, videoHost,posterUrl) => {
    currentVideoId = videoId;
    currentVideoHost = videoHost;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden'; 
    
    if (posterUrl) {
      popupThumbnail.style.backgroundImage = `url('${posterUrl}')`; 
    } else {
      popupThumbnail.style.backgroundImage = 'none';
    }

    iframeContainer.innerHTML = '';
    popupPlayOverlay.style.display = 'flex';
  };

const closeModal = () => {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    iframeContainer.innerHTML = '';
    popupThumbnail.style.backgroundImage = 'none'; 
    currentVideoId = '';
    currentVideoHost = '';
  };

  const startVideoPlayback = () => {
    if (!currentVideoId || !currentVideoHost) return;

    popupPlayOverlay.style.display = 'none';

    let iframeSrc = '';

    if (currentVideoHost === 'youtube') {
     
      iframeSrc = `https://www.youtube.com/embed/${currentVideoId}?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1`;
    } else if (currentVideoHost === 'vimeo') {
      iframeSrc = `https://player.vimeo.com/video/${currentVideoId}?autoplay=1&autopause=1&transparent=0&responsive=1&portrait=0&title=0&byline=0`;
    }

    if (iframeSrc) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', iframeSrc);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      iframe.setAttribute('title', 'Video Player');
      iframeContainer.appendChild(iframe);
    }
  };

 videoTriggers.forEach(trigger => {
  trigger.addEventListener('click', (event) => {
    if (isDragging) {
      event.preventDefault();
      return; // prevents popup opening after drag
    }

    const videoId = trigger.dataset.videoId;
    const videoHost = trigger.dataset.videoHost;
    const posterUrl = trigger.dataset.posterUrl;

    if (videoId) {
      openModal(videoId, videoHost, posterUrl);
    }
  });
});


  backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });

  popupPlayButton.addEventListener('click', startVideoPlayback);

});

// Blog video channel video popup end 



// Faq with Filter section page js start


document.addEventListener('DOMContentLoaded', function() {
  // Category navigation - smooth scroll to category
  const navItems = document.querySelectorAll('.faq-nav-item');
  const categoryContents = document.querySelectorAll('.faq-category-content');
  
  // Set first nav item as active by default
  if (navItems.length > 0) {
    navItems[0].classList.add('active');
  }
  
  navItems.forEach((item, index) => {
    item.addEventListener('click', function() {
      const blockId = this.getAttribute('data-category');
      
      // Update active states
      navItems.forEach(nav => nav.classList.remove('active'));
      this.classList.add('active');
      
      // Smooth scroll to the category
      const targetCategory = document.getElementById('category-' + blockId);
      if (targetCategory) {
        targetCategory.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  
  // FAQ toggle functionality
  const faqToggles = document.querySelectorAll('.faq-toggle');
  
  faqToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const faqItem = this.closest('.faq-item');
      const answer = faqItem.querySelector('.faq-answer');
      const plusIcon = this.querySelector('.icon-plus');
      const minusIcon = this.querySelector('.icon-minus');
      
      if (answer.classList.contains('active')) {
        answer.classList.remove('active');
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
      } else {
        answer.classList.add('active');
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
      }
    });
  });
  
  // Allow clicking question row to toggle
  const questionRows = document.querySelectorAll('.faq-question-row');
  questionRows.forEach(row => {
    row.addEventListener('click', function(e) {
      if (!e.target.closest('.faq-toggle')) {
        const toggle = this.querySelector('.faq-toggle');
        if (toggle) toggle.click();
      }
    });
  });
  
  // Search functionality - BUTTON CLICK ONLY
  const searchInput = document.getElementById('faq-search');
  const searchButton = document.querySelector('.faq-search-btn');
  const noResults = document.querySelector('.no-results');
  
  function performSearch() {
    const searchTerm = searchInput.value.toLowerCase().trim();
    
    if (searchTerm === '') {
      // Reset to show all content when search is empty
      categoryContents.forEach(content => {
        content.style.display = 'block';
        const items = content.querySelectorAll('.faq-item');
        items.forEach(item => item.style.display = 'block');
      });
      navItems.forEach(nav => nav.style.display = 'flex');
      noResults.style.display = 'none';
      return;
    }
    
    let foundResults = false;
    
    categoryContents.forEach((content, index) => {
      const questions = content.querySelectorAll('.faq-question');
      let categoryHasResults = false;
      
      questions.forEach(question => {
        const questionText = question.textContent.toLowerCase();
        const answerText = question.closest('.faq-item').querySelector('.faq-answer-content').textContent.toLowerCase();
        const faqItem = question.closest('.faq-item');
        
        if (questionText.includes(searchTerm) || answerText.includes(searchTerm)) {
          faqItem.style.display = 'block';
          categoryHasResults = true;
          foundResults = true;
        } else {
          faqItem.style.display = 'none';
        }
      });
      
      // Show/hide category content based on results
      content.style.display = categoryHasResults ? 'block' : 'none';
      
      // Show/hide corresponding nav item (faq-left-side-content)
      if (navItems[index]) {
        navItems[index].style.display = categoryHasResults ? 'flex' : 'none';
      }
    });
    
    // Show no results message if no matches found
    if (!foundResults) {
      noResults.innerHTML = '<p>No matching questions found. Please try a different search term.</p>';
      noResults.style.display = 'block';
    } else {
      noResults.style.display = 'none';
    }
  }
  
  // Only trigger search on button click
  if (searchButton){
  searchButton.addEventListener('click', performSearch);
  }
  // Allow Enter key to trigger search
  if (searchInput){
  searchInput.addEventListener('keyup', function(event) {
    if (event.key === 'Enter') {
      performSearch();
    }
  });
  }
});

//  Faq with Filter section page js end

// knowledge all faq page js Start

  document.addEventListener('DOMContentLoaded', function() {
    // FAQ Toggle - Allow multiple open with smooth animation
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.parentElement;
        const faqAnswer = faqItem.querySelector('.faq-answer');
        const isActive = faqItem.classList.contains('active');
        
        // Toggle the clicked FAQ only (don't close others)
        if (isActive) {
          // Closing - set specific height then transition to 0
          faqAnswer.style.maxHeight = faqAnswer.scrollHeight + 'px';
          setTimeout(() => {
            faqAnswer.style.maxHeight = '0px';
          }, 10);
          faqItem.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
        } else {
          // Opening - set height to actual content height
          faqItem.classList.add('active');
          faqAnswer.style.maxHeight = faqAnswer.scrollHeight + 'px';
          this.setAttribute('aria-expanded', 'true');
          
          // After transition, set to none for dynamic content
          setTimeout(() => {
            if (faqItem.classList.contains('active')) {
              faqAnswer.style.maxHeight = 'none';
            }
          }, 300);
        }
      });
    });

    // View All FAQs functionality (mobile only)
    const viewAllBtn = document.getElementById('viewAllFaq');
    const faqList = document.getElementById('faqList');
    
    if (viewAllBtn && faqList) {
      viewAllBtn.addEventListener('click', function() {
        faqList.classList.add('view-all');
        this.style.display = 'none';
      });
    }
  });

// knowledge all faq page js end


// compare button js start
function initCompareScrollbar() {
  const el = document.querySelector('.compare-products-list');
  if (!el) return;

  const updateProgress = () => {
    const maxScroll = el.scrollWidth - el.clientWidth;
    if (maxScroll <= 0) return;

    const progress = (el.scrollLeft / maxScroll) * 100;
    el.style.setProperty('--progress', `${progress}%`);
  };

  
  updateProgress();

  el.addEventListener('scroll', updateProgress);
}


document.addEventListener('DOMContentLoaded', initCompareScrollbar);


document.addEventListener('shopify:section:load', initCompareScrollbar);

// compare button js end


// quick add to open cart drawer starts
document.addEventListener("click", function (e) {
  const btn = e.target.closest('#quick-buy-modal-content button[is="custom-button"]');
  if (!btn) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

 setTimeout(() => {
    if (typeof drawer.toggle === 'function') {
      drawer.toggle();
    } else if (typeof drawer.open === 'function') {
      drawer.removeAttribute('open');
      drawer.open();
    } else {
      drawer.classList.add('show-close-cursor');
      drawer.setAttribute('open', '');
      drawer.style.visibility = 'visible';
      drawer.style.opacity = '1';
      drawer.style.transform = 'translateX(0);'
    }

    
    
  }, 1500);
});

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const banners = document.querySelectorAll('.banner--success');

    banners.forEach(banner => {
      const grandParent = banner.parentElement?.parentElement;
      if (grandParent && grandParent.classList.contains('quick-buy-drawer')) {
        grandParent.style.display = 'none';
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// quick add to open cart drawer ends

// product Thumbnail issue on ios
document.querySelectorAll('.product-gallery__thumbnail').forEach((thumb) => {
  thumb.addEventListener('click', function () {
    // 1. Remove aria-current from all
    document.querySelectorAll('.product-gallery__thumbnail').forEach(t => {
      t.setAttribute('aria-current', 'false');
    });

    // 2. Add aria-current to the clicked one
    this.setAttribute('aria-current', 'true');

    // 3. iOS FIX — force repaint
    this.style.display = 'none';
    this.offsetHeight;      // trigger reflow
    this.style.display = '';
  });
});

// 18-03 changes
document.querySelectorAll('details[is="mega-menu-disclosure"]').forEach(menu => {
  menu.addEventListener('toggle', function() {
    if (this.open) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  });
});



(function () {
  const CONTAINER_ID = "#app-embed-container-787661";
  const MAX_WAIT_MS = 10000; // stop trying after 10s
  const INTERVAL_MS = 200;

  function applyStyle(shadowRoot) {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`#app-embed { z-index: 998 !important; }`);
    shadowRoot.adoptedStyleSheets = [
      ...shadowRoot.adoptedStyleSheets,
      sheet,
    ];
  }

  function tryApply() {
    const container = document.querySelector(CONTAINER_ID);
    if (!container) return false;

    const shadow = container.shadowRoot;
    if (!shadow) return false;

    applyStyle(shadow);
    return true;
  }

  // Try immediately first
  if (tryApply()) return;

  // Poll until element appears or timeout
  const start = Date.now();
  const timer = setInterval(() => {
    if (tryApply()) {
      clearInterval(timer);
      return;
    }
    if (Date.now() - start >= MAX_WAIT_MS) {
      clearInterval(timer);
      console.warn(`[applyStyle] ${CONTAINER_ID} never appeared — skipping.`);
    }
  }, INTERVAL_MS);
})();
